function firebaseConfig() {
  const testConfig = {
    apiKey: "AIzaSyAeWt_CBighx9b1nXFNUzpyatEO3qTZTwU",
    authDomain: "nix-test.firebaseapp.com",
    databaseURL: "https://nix-test.firebaseio.com",
    storageBucket: "nix-test.appspot.com",
    messagingSenderId: "474900300661"
  };
  const alphaConfig = {
    apiKey: "AIzaSyB9kaWQh3m65adk9egawaTK_TWXqCOOnuQ",
    authDomain: "bethel-tv-dev-e1a44.firebaseapp.com",
    databaseURL: "https://bethel-tv-dev-e1a44.firebaseio.com",
    projectId: "bethel-tv-dev-e1a44",
    storageBucket: "bethel-tv-dev-e1a44.appspot.com",
    messagingSenderId: "807578204595"
  };

  firebase.initializeApp(alphaConfig);
}

export default firebaseConfig;



/** WEBPACK FOOTER **
 ** ./src/app/app.firebase.config.js
 **/